<script>
import Fuse from 'fuse.js';

let options = {
    includeScore: true,
    threshold: 0.2,
    includeMatches: true,
    distance: 100,
    keys: ['range', 'name', 'dimensions', 'bedrooms']
  };

// Vue Search
export default {

  name: "VueWooSearch",

  data() {
    return {
        searchQuery : '',
        searchIsLoading: true,
        allAttributes: [],
        searchResults: [],
        filteredSearchResults: [],
        fuse: new Fuse([], options)
      }
    },

    methods: {

      fetchData: function () {
        fetch(`/wp-json/pemberton/v1/products?per_page=99`)
        .then(response => response.json())
        .then(response => {

          this.searchIsLoading = false;
          const data = response;

          data.map((item) => {
            this.searchResults.push(item)
            // console.log(item);
          })

          this.fuse.setCollection(this.searchResults);
        })

      },

      filterSearchResults: function(e){
        searchQuery = e.target.value;
        let filterQuery = this.fuse.search(searchQuery);
        this.filteredSearchResults = filterQuery;
      },


      clearSearchQuery: function (id){
        this.searchQuery = null;
        this.filteredSearchResults = [];
      },

    },

  mounted(){
    this.fetchData()
  },
}

</script>

  <template>

      <div class="search-wrapper">
        <input type="search" placeholder="Search" v-model="this.searchQuery" @keydown.esc="clearSearchQuery" @keyup="filterSearchResults" :disabled="this.searchIsLoading"/>
          <button v-if="this.searchQuery" @click.prevent="clearSearchQuery" class="searchInput-icon clear unstyled-button"></button>
      </div>

      <div v-if="filteredSearchResults.length > 0">

        <div v-if="this.searchIsLoading" class="loader-wrapper">
          <div class="loader"></div>
        </div>

        <ul class="searchList">
          <li class="searchList-item" v-for="(post, index) in filteredSearchResults" :key="post.item.id">

          <a class="searchList-item-link" :href="post.item.term_link">

            <!-- {{console.log(post.item.image)}} -->
            <div v-if="post.item.image" class="searchList-item-image-wrapper">
              <img loading="lazy" class="searchList-item-image" :src="post.item.image" width="170" :alt="post.item.name"/>
            </div>

            <div class="searchList-item-content">

                <div class="searchList-item-content-inner">

                  <h3 class="searchList-item-heading" v-html="post.item.range"></h3>

                  <div class="searchList-item-subheading">

                    <!-- Dimensions-->
                    <p class="searchList-item-subheading-attr dimensions" v-if="post.item.dimensions">
                      Size: {{post.item.dimensions + ' '}}
                    </p>

                    <!-- Bedrooms -->
                    <p class="searchList-item-subheading-attr bedrooms" v-if="post.item.bedrooms">
                      Bedrooms: {{post.item.bedrooms + ' '}}
                    </p>

                  </div>

                </div>
              </div>
              </a>
            </li>
          </ul>
        </div>

</template>
